import { redirect } from "react-router-dom"

// add / update auth token
export async function setAuthToken(response) {
  const token = localStorage.setItem("token", JSON.stringify(response))
  return token
}

// get auth token
export function getAuthToken() {
  const token = JSON.parse(localStorage.getItem("token"))
  return token
}

// get token value for root route
export function tokenLoader() {
  return getAuthToken()
}

// check Auth loader if token has been remove reidrect page to login
export function checkAuthLoader() {
  const token = getAuthToken()
  if (!token) {
    return redirect("/login")
  }
  return token
}

// remove Auth Token
export function removeAuthToken() {
  localStorage.removeItem("token")
}

// Check if we have token to prevent to going in login route
export function checkNotLogin() {
  const token = getAuthToken()
  if (token) {
    return redirect("/dashboard")
  }
  return true
}

// check is this role authorized to going in mintioned page
export function authorize(role, allowRoles) {
  const check = allowRoles.includes(role)
  if (!check) {
    return redirect("/unauthorized")
  }
}
